import React from 'react';
import { Navigate } from 'react-router-dom';
import Login from '../../components/login/Login';
import { useAuth } from '../../contexts/auth';

export default function LoginPage() {
  const auth = useAuth();

  return auth.user ? <Navigate to='/' replace /> : <Login />;
}
